export enum EMarkdownEditorType { 
    MINIMAL_EDITOR = 'minimal_editor', 
    FULL_EDITOR = 'full-editor'
}

export enum ETextAlign { 
    LEFT = 'left', 
    RIGHT = 'right', 
    CENTER = 'center' 
}

const HEADER_FOOTER_BACKGROUND  = '#16161D';
const DEFAULT_STATE = {
    fontSize: 100,
    backgroundColor: HEADER_FOOTER_BACKGROUND,
}
const FONT_SIZE_MARK_STYLE = { color: 'black' };
export { DEFAULT_STATE, HEADER_FOOTER_BACKGROUND, FONT_SIZE_MARK_STYLE }